export enum PaymentOptions {
    CHECK = 'CHECK',
    ACH = 'ACH',
}

export const paymentOptionsList: string[] = Object.values(PaymentOptions);
